export const headerPaneNames = ['notifications', 'teamsChat', 'rewards'] as const;

export type HeaderPaneName = (typeof headerPaneNames)[number];
